declare namespace $ {

	type $mol_button_minor__hint_shm_hitalama_map_widget_float_settings_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_settings_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_settings_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['controlled_title_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_settings_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['controlled_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_settings_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['controlled_title_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_settings_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_settings_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_settings_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $shm_hitalama_text_editor__hint_shm_hitalama_map_widget_float_settings_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['textarea_hint'] >
		,
		ReturnType< $shm_hitalama_text_editor['hint'] >
	>
	type $shm_hitalama_text_editor__sidebar_showed_shm_hitalama_map_widget_float_settings_10 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_text_editor['sidebar_showed'] >
	>
	type $shm_hitalama_text_editor__value_shm_hitalama_map_widget_float_settings_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['code'] >
		,
		ReturnType< $shm_hitalama_text_editor['value'] >
	>
	type $shm_hitalama_text_editor__spellcheck_shm_hitalama_map_widget_float_settings_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_hitalama_text_editor['spellcheck'] >
	>
	type $shm_hitalama_text_editor__owner_shm_hitalama_map_widget_float_settings_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['controlled_widget'] >
		,
		ReturnType< $shm_hitalama_text_editor['owner'] >
	>
	type $shm_hitalama_text_editor__images_enabled_shm_hitalama_map_widget_float_settings_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['markdown_images_enabled'] >
		,
		ReturnType< $shm_hitalama_text_editor['images_enabled'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_settings_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['code_label'] >
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_settings_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings['Code'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	export class $shm_hitalama_map_widget_float_settings extends $shm_hitalama_map_widget_float {
		controlled_widget( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_settings['widget'] >['controlled_widget'] >
		Controlled_widget_open_icon( ): $mol_icon_image
		controlled_title_click( next?: any ): any
		Controlled_widget_open( ): $mol_button_minor
		controlled_title( ): string
		Controlled_title( ): $mol_button_minor
		Settings_head( ): $mol_view
		controlled_settings_content( ): readonly(any)[]
		Settings_content( ): $mol_list
		Settings_scroll( ): $mol_scroll
		code_label( ): string
		textarea_hint( ): string
		code( next?: string ): string
		markdown_images_enabled( ): boolean
		Code( ): $shm_hitalama_text_editor
		widget( ): $shm_hitalama_map_widget
		controlled_type_name( ): string
		tools_custom( ): readonly(any)[]
		controls( ): readonly(any)[]
		text( next?: string ): string
		Code_label( ): $mol_labeler
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map